import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./chatbot.component.scss";
import exportimages from "../../../assets/images/exportImages";
import { OverlayPanel } from "primereact/overlaypanel";
import { useDispatch, useSelector } from "react-redux";
import {
  addBotMessage,
  addUserMessage,
  chatbotHistoryThunk,
  resetChatbotHistory,
  setChatbotHistory,
  setStreaming,
} from "../../../rtk-query/features/chatbot/chatbotSlice";
import store from "../../../app/store";
import loaderImage from "../../../assets/images/Chatbot_animated_loader.gif";
import animated_loader_img from "../../../assets/images/animation_loader.gif";
import DOMPurify from "dompurify";
import { _post } from "../../../api/chatbotApiClient";
import {
  botResponse$,
  userMessage$,
} from "../../Bank/report/widget/EWiChatBot/chatStream";
import moment from "moment";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const Chatbot = () => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  const orguid = store.getState().orgReducer.selectedFI?.orguid;

  const [input, setInput] = useState("");
  const textareaRef = useRef(null);
  const chatbotContainerWrapperRef = useRef(null);

  const { messages, chatbotIsStreaming, chatbotHistory, loading, page } =
    useSelector((state) => state.chatbotReducer);

  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [botStatus, setBotStatus] = useState("");
  const [showAutopilotLabel, setShowAutopilotLabel] = useState(false);
  let interval;

  const overlayRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    const subscription = botResponse$.subscribe((response) => {
      dispatch(
        addBotMessage({
          dateTime: moment(),
          sender: "bot-msg",
          message:
            response?.data?.data?.response ||
            JSON.stringify(response?.data?.data?.response),
        }),
      );
      dispatch(setStreaming(false));
    });

    return () => subscription.unsubscribe();
  }, [dispatch]);

  const MAX_HEIGHT = 160; // 10rem

  const handleChange = (e) => {
    const value = e?.target?.value;
    setInput(value);

    const textarea = textareaRef.current;
    const container = chatbotContainerWrapperRef.current;

    if (!textarea || !container) return;

    // textarea.style.height = "auto";

    // const newHeight = Math.min(textarea.scrollHeight, MAX_HEIGHT);

    // textarea.style.height = `${newHeight}px`;
    // textarea.style.overflowY =
    //   textarea.scrollHeight > MAX_HEIGHT ? "auto" : "hidden";

    // if (textarea.scrollHeight <= MAX_HEIGHT) {
    //   container.style.maxHeight = `calc(100vh - 20.45rem - ${newHeight}px)`;
    // }

    textarea.style.height = "auto";

    const computed = window.getComputedStyle(textarea);
    const lineHeight = parseFloat(computed.lineHeight);
    const paddingTop = parseFloat(computed.paddingTop);
    const paddingBottom = parseFloat(computed.paddingBottom);

    const maxLines = 2;
    const maxHeight = lineHeight * maxLines + paddingTop + paddingBottom;

    const chatbot_container = document.querySelector(".chatbot_container");
    const inputWrapper = textarea.parentElement;

    if (textarea.scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + "px"; // LOCK height
      textarea.style.overflowY = "auto";
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden";
    }

    // Dynamically adjust chatbot_container height
    const inputHeight = inputWrapper.offsetHeight;
    chatbot_container.style.height = `calc(100% - ${inputHeight + 5.2 * 13}px)`;
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault(); // prevents new line
      sendMessage();
    }
  };

  const resetTextareaHeight = () => {
    const textarea = document.querySelector(".chat-input");
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.overflowY = "hidden";

    const chatbot_container = document.querySelector(".chatbot_container");
    const inputWrapper = textarea.parentElement;

    const inputHeight = inputWrapper.offsetHeight;
    chatbot_container.style.height = `calc(100% - ${inputHeight + 5.2 * 13}px)`;
  };

  const sendMessage = () => {
    if (!input.trim()) return;

    dispatch(setStreaming(true));

    const messageObj = {
      dateTime: moment(),
      sender: "user-msg",
      message: input,
    };

    dispatch(addUserMessage(messageObj));

    userMessage$.next(messageObj);

    setInput("");
    resetTextareaHeight();
  };

  useEffect(() => {
    if (!chatbotIsStreaming) return;

    setBotStatus("");

    const statuses = ["Thinking...", "Analysing...", "Calculating..."];
    let index = 0;

    const loaderTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    const statusInterval = setInterval(() => {
      setBotStatus(statuses[index % statuses.length]);
      index++;
    }, 3000);

    return () => {
      clearTimeout(loaderTimeout);
      clearInterval(statusInterval);
    };
  }, [chatbotIsStreaming]);

  useEffect(() => {
    const container = document.querySelector(".chatbot_container");
    if (!container) return;

    const scrollToBottom = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const isOverflowing = container.scrollHeight > container.clientHeight;

          if (isOverflowing) {
            bottomRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "end",
            });
            setShowAutopilotLabel(true);
          } else {
            setShowAutopilotLabel(false);
          }
        });
      });
    };

    scrollToBottom();
  }, [messages, isOverlayOpen]);

  useEffect(() => {
    const resize = () => {
      const vh = window.innerHeight;
      document.documentElement.style.setProperty(
        "--chat-height",
        `${vh * 0.85}px`,
      );
    };

    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const customFormating = (context) => {
    // replaced " - " with " "
    const cleanedText = context?.replace(/ — /g, " ");
    return cleanedText;
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-link flip-container"
        onClick={(e) => {
          overlayRef.current.toggle(e);
          // dispatch(chatbotHistoryThunk({ page: page }));
        }}
        style={{ display: isOverlayOpen ? "none" : "block" }}
        // style={{ position: "absolute" }}
      >
        <div className="front">
          <img
            src={exportimages?.bont_bot_icon_from}
            className="frontImg"
            alt=""
          />
          <img
            src={exportimages?.bont_bot_icon_back}
            className="backImg"
            alt=""
          />
        </div>
      </button>

      <OverlayPanel
        ref={overlayRef}
        onShow={() => setIsOverlayOpen(true)}
        onHide={() => setIsOverlayOpen(false)}
        className="chatbot_wrapper"
      >
        <div className="chatbot_pannel">
          <div className="chatbot_header">
            <div class="d-flex bd-highlight">
              <div class="me-auto bd-highlight">
                <img
                  src={exportimages?.chatbot_main_icon}
                  className="img-fluid"
                />
                {showAutopilotLabel && !loading && (
                  <label className="autopilot-label">Autopilot Assist</label>
                )}
              </div>
              <div class="bd-highlight">
                <button
                  type="button"
                  className="btn btn-link py-0"
                  onClick={() => {
                    overlayRef.current.hide();
                    setIsOverlayOpen(false);
                  }}
                >
                  <img
                    src={exportimages?.chatbot_Close_icon}
                    className="img-fluid"
                  />
                </button>
              </div>
            </div>
          </div>
          <div
            className="chatbot_container"
            ref={chatbotContainerWrapperRef}
            // onScroll={(e) => {
            //   handleScroll(e);
            // }}
          >
            <div className="test">
              <label className="header_one">
                Hello{" "}
                {`${authReducer?.userData?.firstName} ${authReducer?.userData?.lastName}`}
                !
              </label>
              <label className="header_two">I am ARIA</label>
              <p className="subTitle">
                {/* This assistant is designed only for EWI queries. Enter your EWI
                question to continue.
                 */}
                I’m your virtual analyst for strategic banking decisions.
              </p>
            </div>
            {messages.map((msg, i) => {
              return (
                <div className="chatbot-msg d-flex flex-column justify-content-end">
                  <span key={i} className={`text-msg ${msg?.sender}`}>
                    {msg?.sender === "bot-msg" ? (
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {customFormating(msg?.message)}
                      </ReactMarkdown>
                    ) : (
                      msg?.message
                    )}
                  </span>
                  <p
                    className="createdOn"
                    style={{
                      textAlign: msg?.sender === "user-msg" ? "end" : "start",
                      width: "95%",
                    }}
                  >
                    {msg.dateTime
                      ? moment(msg.dateTime).format("dddd h:mm A")
                      : ""}
                  </p>
                </div>
              );
            })}

            {/* {loading ? (
              <div className="animated_loader">
                <img
                  alt="loader"
                  loading="lazy"
                  src={animated_loader_img}
                  className="loaderImg"
                  style={{ height: "4rem" }}
                />
              </div>
            ) : (
              <>
                {chatbotHistory?.map((chat, index) => (
                  <div
                    key={index}
                    className="chatbot-msg d-flex flex-column justify-content-end"
                  >
                    <span
                      className={`text-msg ${chat.sender === "user" ? "user-msg" : "bot-msg"}`}
                      dangerouslySetInnerHTML={{
                        __html:
                          chat.sender === "bot"
                            ? DOMPurify.sanitize(chat.text)
                            : DOMPurify.sanitize(chat.text),
                      }}
                    />

                    <p
                      className="createdOn"
                      style={{
                        textAlign: chat.sender === "user" ? "end" : "start",
                        width: "95%",
                      }}
                    >
                      {chat?.createdOn}
                    </p>
                  </div>
                ))}
              </>
            )} */}
            <div ref={bottomRef} />

            <div className="chatbot_animated_loader">
              {chatbotIsStreaming && (
                <>
                  {!botStatus && (
                    <img
                      alt="loader"
                      loading="lazy"
                      src={loaderImage}
                      className="img-fluid"
                      style={{ height: "4rem" }}
                    />
                  )}
                  {botStatus && (
                    <div
                      className="bot-status-text text-center"
                      style={{ height: "3rem" }}
                    >
                      {botStatus}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/********** // this code is for Follow up question. **************/}
          {/*{specialBotText && (
            <>
              <div
                className="special-question-box"
                ref={specialBoxRef}
                onClick={sendMessage}
              >
                <img
                  src={exportimages?.chatbot_question_icon}
                  className="img-fluid"
                />
                {specialBotText}
              </div>
            </>
          )} */}
          <div className="chatbot_footer">
            <div class="input-group gradient-border">
              <textarea
                ref={textareaRef}
                value={input}
                className="form-control form-control-lg chat-input"
                placeholder="Ask about EWI, risk signals…"
                rows={1}
                disabled={chatbotIsStreaming}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                style={{ overflow: "hidden", resize: "none" }}
              />
              <button
                type="button"
                className="btn btn-link py-0 send-icon"
                onClick={sendMessage}
                disabled={chatbotIsStreaming}
              >
                <img
                  src={exportimages?.chatbot_send_icon}
                  className="img-fluid"
                />
              </button>
            </div>
          </div>
        </div>
      </OverlayPanel>
    </>
  );
};
